export { Slider } from './Slider';
export type { SliderHandle, SliderProps, SnapDirection } from './Slider';
